/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Button,
  Card,
  CardImg,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

class CardsFooter extends React.Component {
  render() {
    return (
      <>
        <footer className="footer has-cards">
          <Container className="container-lg" style={{ height: 200 }}>
            {/* <Row>
              <Col className="mb-5 mb-md-0" md="6">
                <Card className="card-lift--hover shadow border-0">
                  <Link to="/landing-page">
                    <CardImg
                      alt="..."
                      src={require("assets/img/theme/landing.jpg")}
                    />
                  </Link>
                </Card>
              </Col>
              <Col className="mb-5 mb-lg-0" md="6">
                <Card className="card-lift--hover shadow border-0">
                  <Link to="/profile-page">
                    <CardImg
                      alt="..."
                      src={require("assets/img/theme/profile.jpg")}
                    />
                  </Link>
                </Card>
              </Col>
            </Row> */}
          </Container>
          <Container>
            <Row className="row-grid align-items-center my-md">
              <Col lg="6">
                <h3 className="text-primary font-weight-light mb-2">
                  Kanero,
                </h3>
                <h4 className="mb-0 font-weight-light">
                  Just because we can
                </h4>
              </Col>
              {/* <Col className="text-lg-center btn-wrapper" lg="6">
                <Button
                  className="btn-icon-only rounded-circle"
                  color="twitter"
                  href="https://twitter.com/kanero"
                  id="tooltip475038074"
                  target="_blank"
                >
                  <span className="btn-inner--icon">
                    <i className="fa fa-twitter" />
                  </span>
                </Button>
                <UncontrolledTooltip delay={0} target="tooltip475038074">
                  Follow us
                </UncontrolledTooltip>
                <Button
                  className="btn-icon-only rounded-circle ml-1"
                  color="facebook"
                  href="https://www.facebook.com/kanero"
                  id="tooltip837440414"
                  target="_blank"
                >
                  <span className="btn-inner--icon">
                    <i className="fa fa-facebook-square" />
                  </span>
                </Button>
                <UncontrolledTooltip delay={0} target="tooltip837440414">
                  Like us
                </UncontrolledTooltip>
                <Button
                  className="btn-icon-only rounded-circle ml-1"
                  color="github"
                  href="https://github.com/kanero"
                  id="tooltip495507257"
                  target="_blank"
                >
                  <span className="btn-inner--icon">
                    <i className="fa fa-github" />
                  </span>
                </Button>
                <UncontrolledTooltip delay={0} target="tooltip495507257">
                  Star on Github
                </UncontrolledTooltip>
              </Col> */}

            </Row>
            <hr />
            {/* <Row className="align-items-center justify-content-md-between">
              <Col md="6">
                <div className="copyright">
                  © {new Date().getFullYear()}{" "}
                  <a
                    href="https://www.creative-tim.com?ref=adsr-footer"
                    target="_blank"
                  >
                    Creative Tim
                  </a>
                  .
                </div>
              </Col>
              <Col md="6">
                <Nav className="nav-footer justify-content-end">
                  <NavItem>
                    <NavLink
                      href="https://www.creative-tim.com?ref=adsr-footer"
                      target="_blank"
                    >
                      Creative Tim
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="https://www.creative-tim.com/presentation?ref=adsr-footer"
                      target="_blank"
                    >
                      About Us
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="http://blog.creative-tim.com?ref=adsr-footer"
                      target="_blank"
                    >
                      Blog
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md"
                      target="_blank"
                    >
                      MIT License
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
             */}
            <section className="section" id="footer">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-3" style={{ fontSize: "small" }}>
                    <ul className="footer-menu pl-sm-0">
                      <h5 className="footer-title "><strong>Contact</strong></h5>
                      <li className="footer-text pb-1"><a href="tel:233245089490">+233 245 089490</a></li>
                      <li className="footer-text pb-4"><a href="tel:233240099502">+233 240 099502</a></li>
                      <li className="footer-text pb-1 "><a href="mailto:kanerocompany@gmail.com">kanerocompany@gmail.com</a></li>
                    </ul>
                    <ul className="footer-menu pl-sm-0">
                      <h5 className="footer-title "><strong>Working hours</strong></h5>

                      <li className="footer-text ">Mon - Fri | 8:00am - 5:00pm</li>
                      <li className="footer-text ">Sat | 9:00am - 2:00pm</li>
                    </ul>
                  </div>
                  <div className="col-md-9" style={{ fontSize: "small" }}>
                    <div className="row">
                      <div className="col-md-3 col-6">
                        <ul className="footer-menu ml-0 pl-0">
                          <h5 className="footer-title"><strong>Our Products</strong></h5>
                          <li className="nav-item">
                            <a href="products/voting" className="footer-text nav-link mb-sm-3 mb-md-0">Voting</a>
                          </li>
                          <li className="nav-item">
                            <a href="products/ffa" className="footer-text nav-link mb-sm-3 mb-md-0">Field Force Automation</a>
                          </li>
                          <li className="nav-item">
                            <a href="products/school-management" className="footer-text nav-link mb-sm-3 mb-md-0">School management</a>
                          </li>
                          <li className="nav-item">
                            <a href="products/open-shop" className="footer-text nav-link mb-sm-3 mb-md-0">E-Commerce</a>
                          </li>
                          <li className="nav-item">
                            <a href="products/chatbot" className="footer-text nav-link mb-sm-3 mb-md-0">Website chatbot</a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-3 col-6">
                        <ul className="footer-menu ml-0 pl-0">
                          <h5 className="footer-title"><strong>Our Solutions</strong></h5>
                          <li className="nav-item">
                            <a href="solutions/notifications" className="footer-text nav-link mb-sm-3 mb-md-0">Notifications</a>
                          </li>
                          <li className="nav-item">
                            <a href="solutions/payments" className="footer-text nav-link mb-sm-3 mb-md-0">Payment Gateway</a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-3 col-6">
                        <ul className="footer-menu ml-0 pl-0">
                          <h5 className="footer-title"><strong>Our Services</strong></h5>
                          <li className="nav-item">
                            <a href="services/software-development" className="footer-text nav-link mb-sm-3 mb-md-0">Software development</a>
                          </li>
                          <li className="nav-item">
                            <a href="services/consultations" className="footer-text nav-link mb-sm-3 mb-md-0">Consultation</a>
                          </li>
                          <li className="nav-item">
                            <a href="services/server-management" className="footer-text nav-link mb-sm-3 mb-md-0">Server management</a>
                          </li>
                          <li className="nav-item">
                            <a href="services/tuition" className="footer-text nav-link mb-sm-3 mb-md-0">Tuition</a>
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-3 col-6">
                        <ul className="footer-menu ml-0 pl-0">
                          <h5 className="footer-title"><strong>Developers</strong></h5>
                          <li className="nav-item ">
                            <a href="https://docs.notifications.kanero.net/sms" className="footer-text nav-link mb-sm-3 mb-md-0">SMS API</a>
                          </li>
                          <li className="nav-item ">
                            <a href="https://docs.notifications.kanero.net/whatsapp-business" className="footer-text nav-link mb-sm-3 mb-md-0">WhatsApp Business API</a>
                          </li>
                          <li className="nav-item ">
                            <a href="https://docs.notifications.kanero.net/push" className="footer-text nav-link mb-sm-3 mb-md-0">Push Notifications API</a>
                          </li>
                          <li className="nav-item ">
                            <a href="https://docs.notifications.kanero.net/voice" className="footer-text nav-link mb-sm-3 mb-md-0">Voice Messaging API</a>
                          </li>
                          <li className="nav-item ">
                            <a href="https://docs.auth.kanero.net/mfa" className="footer-text nav-link mb-sm-3 mb-md-0">MFA API</a>
                          </li>
                          <li className="nav-item ">
                            <a href="https://docs.auth.kanero.net/soo" className="footer-text nav-link mb-sm-3 mb-md-0">Single-Sign-On API</a>
                          </li>
                          <li className="nav-item ">
                            <a href="https://docs.payments.kanero.net" className="footer-text nav-link mb-sm-3 mb-md-0">Payments API</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-fluid pl-5 pr-5 copyright-line">
                <div className="row">
                  <div className="col">
                    <small className="">Copyright @ 2019 - 2020 Kanero Company Ltd | All Rights Reserved</small>
                  </div>
                </div>
                  <div className="row attribution">
                    <a target='_blank' style={{color: '#075b6a'}} href="https://www.creative-tim.com?ref=adsr-footer">Powered by Argon Template (Creative Tim)</a>
                  </div>
              </div>
            </section>
          </Container>
          <a className="whatsapp-logo-container" href="https://wa.me/233245089490" target="_blank">
            <img className="whastapp-logo" src={require('../../assets/img/brand/whatsapp.png')} alt="Whatsapp Logo" width="50px" />
          </a>
        </footer>
      </>
    );
  }
}

export default CardsFooter;
